import { render, staticRenderFns } from "./BusinessProfileForm.vue?vue&type=template&id=7815ef22&"
import script from "./BusinessProfileForm.vue?vue&type=script&lang=js&"
export * from "./BusinessProfileForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports